/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesInviteEmailInviteResponse interface.
 */
export function instanceOfFxIdWebFeaturesInviteEmailInviteResponse(value) {
    if (!('Success' in value) || value['Success'] === undefined)
        return false;
    if (!('Error' in value) || value['Error'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesInviteEmailInviteResponseFromJSON(json) {
    return FxIdWebFeaturesInviteEmailInviteResponseFromJSONTyped(json, false);
}
export function FxIdWebFeaturesInviteEmailInviteResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Success': json['Success'],
        'Error': json['Error'],
        'Token': json['Token'] == null ? undefined : json['Token'],
    };
}
export function FxIdWebFeaturesInviteEmailInviteResponseToJSON(json) {
    return FxIdWebFeaturesInviteEmailInviteResponseToJSONTyped(json, false);
}
export function FxIdWebFeaturesInviteEmailInviteResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Success': value['Success'],
        'Error': value['Error'],
        'Token': value['Token'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesInviteEmailInviteResponse.js.map